<div class="color-grease d-flex align-items-center">
  <i class="pi pi-ban me-2"></i>
  <span>{{ infoLabel | translate}}</span>
</div>
